export const NAVIGATION = {
  products: 'BottomPRODUCTS',
  contacts: 'BottomCONTACTS',
  support: 'BottomSUPPORT',
  events: 'BottomEVENTS',
  about: 'BottomABOUT',
};

export const SOCIAL_LINKS = [
  { site: 'facebook', url: process.env.REACT_APP_FACEBOOK_URL },
  { site: 'instagram', url: process.env.REACT_APP_INSTAGRAM_URL },
  { site: 'youtube', url: process.env.REACT_APP_YOUTUBE_URL },
  { site: 'twitter', url: process.env.REACT_APP_TWITTER_URL },
  { site: 'tiktok', url: process.env.REACT_APP_TIKTOK_URL },
  { site: 'linkedin', url: process.env.REACT_APP_LINKEDIN_URL },
  { site: 'vimeo', url: process.env.REACT_APP_VIMEO_URL },
  { site: 'pinterest', url: process.env.REACT_APP_PINTEREST_URL },
];

export const COPYRIGHT = 'Copyright © 2019 Divesoft LLC All rights reserved.';



// WEBPACK FOOTER //
// ./src/components/Footer/const.ts